exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".itemData__lastLine___1tY35 {\n  border-bottom: none; }\n", ""]);

// exports
exports.locals = {
	"lastLine": "itemData__lastLine___1tY35"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/DetailsSection/GroupData/itemData.scss
// module id = 4406
// module chunks = 6